
import Grid from "@mui/material/Grid";
import { CircularProgress, Backdrop } from "@mui/material";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Config from "../../config.js";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { handleErrors } from "common.js";
import { CHANGEPASSWORD } from "constants";

function ViewProfile(props) {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const resetPassword = localStorage.getItem('resetPassword');
  const [adminData, setAdminData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const minPasswordLength = 6;

  const data = () => {
    setIsLoading(true);
    axios({
      url: BASE + "api/viewProfile",
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    }).then(function (response) {
      setIsLoading(false)
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setAdminData(response.data)
          setValueFn(response.data.data)
        }
        else {
          if (message != '')
            toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data();
    if (resetPassword && resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET)
      toast.success(t('setNewPasswordBySubAdmin'))
  }, []);

  const { register, handleSubmit, watch, setValue, getValues, setError, formState: { errors } } = useForm();

  const setValueFn = (setValueData) => {
    setValue('name', setValueData.name);
    setValue('email', setValueData.email);
    setValue('password', '');
    setValue('confirmPassword', '');
    setValue('currentPassword', '');
  }

  const onSubmit = async (data) => {
    setIsLoading(true);
    axios({
      url: BASE + "api/editProfile",
      method: "POST",
      data: data,
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(response.data.message))
          localStorage.setItem("resetPassword", CHANGEPASSWORD.RESETPASSWORD_UNSET)
        }
        else {
          if (message != '')
            toast.error(t(message))
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("myProfile")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox  pb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              {(adminData) ?
                <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                  <MDBox px={3}>
                    <Grid container spacing={2} mt={2}>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="generalFont">{t('name')}  <i className="mandatory">*</i></label>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <MDInput type="text" name="name" label="" {...register("name", { required: true })} fullWidth />
                        {errors.name && errors.name.type === "required" && (
                          <p className="errorMsg">{t('nameRequired')}</p>
                        )}
                        {errors.name && (
                          <p className="errorMsg">{t(errors.name.message)}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="generalFont">{t('email')}<i className="mandatory">*</i></label>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <MDInput key={'email'} type="email" name="email" label="" {...register("email", { required: true, pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/ })} fullWidth />
                        {errors.email && errors.email.type === "required" && (
                          <p className="errorMsg">{t('emailRequired')}</p>
                        )}
                        {errors.email && errors.email.type === "pattern" && (
                          <p className="errorMsg">{t('emailNotValid')}</p>
                        )}
                        {errors.email && (
                          <p className="errorMsg">{t(errors.email.message)}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="generalFont">{t('currentPassword')}{resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET ? <i className="mandatory">*</i> : null}</label>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <MDInput
                          type="password"
                          name="currentPassword"
                          {...register("currentPassword", {
                            required: {
                              value: (resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET || getValues('password')) ? true : false,
                              message: t('currentPasswordRequired')
                            },
                            minLength: {
                              value: minPasswordLength,
                              message: t('passwordMinimumLength', { length: minPasswordLength })
                            }
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.currentPassword && (
                          <p className="errorMsg">{t(errors.currentPassword.message)}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="generalFont">{t('newPassword')}{resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET ? <i className="mandatory">*</i> : null}</label>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <MDInput
                          type="password"
                          name="password"
                          {...register("password", {
                            required: {
                              value: resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET ? true : false,
                              message: t('passwordRequired')
                            },
                            minLength: {
                              value: minPasswordLength,
                              message: t('passwordMinimumLength', { length: minPasswordLength })
                            }
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.password && (
                          <p className="errorMsg">{t(errors.password.message)}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="generalFont">{t('confirm password')}{resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET ? <i className="mandatory">*</i> : null}</label>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <MDInput
                          type="password"
                          name="confirmPassword"
                          {...register("confirmPassword", {
                            required: {
                              value: resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET ? true : false,
                              message: t('confirmPasswordRequired')
                            },
                            minLength: {
                              value: minPasswordLength,
                              message: t('passwordMinimumLength', { length: minPasswordLength })
                            },
                            validate: (value) => {
                              if (watch('password') != value) {
                                return t('passwordMismatch');
                              }
                            },
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.confirmPassword && (
                          <p className="errorMsg">{t(errors.confirmPassword.message)}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <MDButton type="submit" variant="gradient" color="info" className="edit-button-mb" disableRipple>{t('update')}</MDButton>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
                : null}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ViewProfile;
